<template>
    <div id="list-brands-component" class="w-full h-full">
        <div class="flex items-end justify-between gap-2">
            <span v-if="isLoading"> Cargando...</span>
            <custom-simple-select
                v-else
                v-model="option"
                label="Marca"
                mode="search"
                class="w-full"
                :options="selectOptions"
                :disabled="!enabled"
                @change="onInput"
            />

            <app-button
                v-if="enabled"
                icon
                circle
                color="brand-purple"
                @click="reloadItems(true)"
            >
                <reload-icon class="h-5 w-5 text-white" />
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "BrandSelector",
    components: { ReloadIcon, CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => ({
                name: "",
                slug: ""
            }),
            type: Object,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        fill: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        option: "",
        options: [],
        isLoading: true
    }),
    computed: {
        ...mapState("control", ["activeDark"]),
        ...mapState("commons", ["brandsShort"]),
        ...mapGetters("control", ["backgroundColor"]),
        selectOptions() {
            return this.options.map((item) => ({
                label: item.name,
                value: item.slug
            }));
        }
    },
    watch: {
        itemCurrent(value) {
            this.setInput(value);
        }
    },
    mounted() {
        this.options = [...this.brandsShort];
        this.setInput(this.itemCurrent);
        if (this.fill) {
            this.reloadItems(true);
        }
    },
    methods: {
        ...mapActions("commons", ["listAllBrandsShort"]),
        async reloadItems(required = true) {
            this.isLoading = true;
            try {
                this.options = await this.listAllBrandsShort({ required });
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        setInput(value) {
            const aux = this.options.find((item) => item.slug === value.slug);
            if (!aux) {
                this.options = [...this.options, value];
            }
            this.option = value.slug ?? "";
            this.isLoading = false;
        },
        onInput() {
            const aux = this.options.find((item) => this.option === item.slug);
            if (aux) {
                this.$emit("change", aux);
            }
        }
    }
};
</script>
